import { connect } from 'react-redux';
import { TAB_CATEGORIES, TAB_ENTRY_SUBMITTED, TAB_ENTRY_UPLOAD } from '../../enums';
import CategorySelection from './categorySelect';
import EntryUpload from './entryUpload';
import { getLabel } from '../../Language/labels';
import { EntryStatus } from './entryStatus';
import { useState, useEffect } from 'react';

const CompetitionTabsWrapper = ({ currentTab, dispatch }) => {

  const [stage, setStage] = useState(1);

  useEffect(() => {
    switch (currentTab) {
      case TAB_CATEGORIES:
        setStage(1);
        break;
      case TAB_ENTRY_UPLOAD:
        setStage(2);
        break;
      case TAB_ENTRY_SUBMITTED:
        setStage(3);
        break;
      default:
        break;
    }
  }, [currentTab]);

  const isActive = (tab, nextTab) => {
    return tab === currentTab || nextTab ? 'active' : '';
  }

  return (
    <>
      <div className="competition-tabs">
        <div className={`competition-tab first ${stage >= 1 ? 'active' : ''}`}>
          <h1>{getLabel('categorySelectTab')}</h1>
        </div>
        <div className={`competition-tab ${stage >= 2 ? 'active' : ''}`}>
          <h1>{getLabel('entryUploadTab')}</h1>
        </div>
        <div className={`competition-tab ${stage >= 3 ? 'active' : ''}`}>
          <h1>{getLabel('entrySubmitTab')}</h1>
        </div>
      </div>

      {isActive(TAB_CATEGORIES) && <CategorySelection dispatch={dispatch} />}
      {isActive(TAB_ENTRY_UPLOAD) && <EntryUpload dispatch={dispatch} />}
      {isActive(TAB_ENTRY_SUBMITTED) && <EntryStatus dispatch={dispatch} />}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    currentTab: state.competitionTabState
  }
}

export default connect(mapStateToProps)(CompetitionTabsWrapper);